import React, { useEffect, useState, Fragment, useRef } from "react";
import { TableContenForLossExcessReport } from '../../../Common/Table/tableContent';
import $ from "jquery";

export default class ComponentToPrint extends React.Component {

    render() {

        const searchData = this.props.searchData;
        const reportData = this.props.data;
        const totalAmount = this.props.totalAmount;
        const dynamicContentRowNames = this.props.dynamicContentRowNames;

        const renderPdf = this.createPdf(searchData, reportData, dynamicContentRowNames, totalAmount);

        return (
            <div>
                {renderPdf}
            </div>
        );

    }

    createPdf(searchData, reportData, dynamicContentRowNames, totalAmount) {
        return (
            <div className="pl-2 pr-2">
                <h3><center><u>Daily Loss/Excess Report</u></center></h3>
                <div className="row pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Estate: </b> {searchData.estate}</div>
                    <div className="col"><b>Division: </b> {searchData.division}</div>
                    <div className="col"><b>Field: </b> {searchData.field}</div>
                    <div className="col"><b>Search Date: </b> {searchData.searchDate}</div>
                </div>
                <div className="table-responsive row-top-gap">
                    <table className="display dataTable no-footer pb-3">
                        <thead>
                            <tr>
                                <th > Field Name </th>
                                <th > Session </th>
                                <th > Checkroll Weight </th>
                                <th > Factory Weight </th>
                                <th > Loss/ Gain </th>
                            </tr>
                        </thead>
                        <tbody>
                            <TableContenForLossExcessReport
                                data={reportData}
                                contentRowNames={dynamicContentRowNames}
                                hasEdit={false}
                            />
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan="2"><b>Total</b></td>
                                <td style={{ textAlign: "right" }}><b>{totalAmount.pluckingCheckrollWeight}</b></td>
                                <td style={{ textAlign: "right" }}><b>{totalAmount.factoryTotal}</b></td>
                                <td style={{ textAlign: "right" }}>
                                    <b>
                                        <h5><span class={totalAmount.lossGain > 0
                                            ? "badge badge-primary" : "badge badge-danger"}>{totalAmount.lossGain.toFixed(2)}
                                        </span></h5>
                                    </b>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        );
    }
}
